export enum AgeGradeVo {
  All = 0,
  Fifteen = 15,
  Eighteen = 18,
  Nineteen = 19,
}
